import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

import { usePostPaymentOnboardingScreen } from './usePostPaymentOnboardingScreen'

type PostPaymentOnboardingContextValue = ReturnType<
  typeof usePostPaymentOnboardingScreen
>

const PostPaymentOnboardingContext =
  createContext<PostPaymentOnboardingContextValue | null>(null)

interface PostPaymentOnboardingProviderProps {
  children: ReactNode
}

export function PostPaymentOnboardingProvider({
  children,
}: PostPaymentOnboardingProviderProps) {
  const value = usePostPaymentOnboardingScreen()

  return (
    <PostPaymentOnboardingContext.Provider value={value}>
      {children}
    </PostPaymentOnboardingContext.Provider>
  )
}

export function usePostPaymentOnboardingContext() {
  const context = useContext(PostPaymentOnboardingContext)

  if (context == null) {
    throw new Error(
      'usePostPaymentOnboardingContext must be used within PostPaymentOnboardingProvider',
    )
  }

  return context
}
